import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { addServer, getServerById, updateServer } from "../services/serverAPI";
import AppMenu from "../components/AppMenu";
import { title } from "../config";
import { BackButton } from "../components/BackButton";
import { useToast } from "../components/ToastContext";

export default function AddServer() {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const { recordId } = useParams();
  const [error, setError] = useState("");

  const [server, setServer] = useState({
    name: "",
    hostname: "",
    ip: "",
    description: "",
    active: 1,
  });

  const [buttonLabel, setButtonLabel] = useState("Add");

  const loadServer = async (id) => {
    const data = await getServerById(id, showToast);
    if (data) {
      setServer(data);
      setButtonLabel("Update");
    }
  };

  useEffect(() => {
    if (recordId) {
      loadServer(recordId);
    }
  }, [recordId]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setServer({
      ...server,
      [name]: type === "checkbox" ? (checked ? 1 : 0) : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!server.name || server.name.trim().length === 0) {
      setError("Server Name is required.");
      return;
    }

    setError("");

    try {
      if (server._id !== undefined) {
        const updated = await updateServer(server, showToast);
        showToast(updated?.msg || "Server updated successfully!", updated?.result === "success" ? "success" : "error");
      } else {
        const added = await addServer(server, showToast);
        showToast(added?.msg || "Server added successfully!", added?.result === "success" ? "success" : "error");
      }
      navigate("/servers");
    } catch (err) {
      console.error(err);
      showToast("An error occurred while saving the server", "error");
    }
  };

  return (
    <div>
      <div className="px-2 sticky-header">
        <h3 className="m-0 p-2">{title} | {buttonLabel} Server</h3>
        <AppMenu />
      </div>
      <div className="p-0 m-0 px-2 pb-2">
        <BackButton text="Back" icon="←" />
        <div className="card p-5">
          <form className="container float-center needs-validation">
            <div className="row">
              <div className="col-md-6 col-sm-12 mb-3">
                <label className="form-label">Server Name <span className="text-danger">*</span></label>
                <input
                  placeholder="e.g. Production Web-01 / SystemQ-Primary"
                  name="name"
                  onChange={handleChange}
                  value={server.name || ""}
                  className="form-control"
                  required
                />
                {error && <span style={{ color: "red" }}>{error}</span>}
              </div>
              <div className="col-md-6 col-sm-12 mb-3">
                <label className="form-label">Hostname / Domain</label>
                <input
                  placeholder="e.g. web01.systemq.com / systemq-server"
                  name="hostname"
                  onChange={handleChange}
                  value={server.hostname || ""}
                  className="form-control"
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-6 col-sm-12 mb-3">
                <label className="form-label">IP Address</label>
                <input
                  placeholder="e.g. 192.168.1.100 / 104.21.5.12"
                  name="ip"
                  onChange={handleChange}
                  value={server.ip || ""}
                  className="form-control"
                />
              </div>
              <div className="col-md-6 col-sm-12 mb-3">
                <label className="form-label">Description / Tags</label>
                <input
                  placeholder="e.g. Ubuntu 22.04 LTS, Hosted on AWS"
                  name="description"
                  onChange={handleChange}
                  value={server.description || ""}
                  className="form-control"
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 mb-3">
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="activeSwitch"
                    name="active"
                    checked={server.active === 1 || server.active === true}
                    onChange={handleChange}
                  />
                  <label className="form-check-label ms-2" htmlFor="activeSwitch">
                    Active (Include in alerts & monitoring)
                  </label>
                </div>
              </div>
            </div>

            <br />
            <div className="row">
              <div className="col-md-2 col-sm-6">
                <input
                  type="button"
                  onClick={handleSubmit}
                  value={buttonLabel}
                  className="btn btn-primary btn-block w-100"
                />
              </div>
              <div className="col-md-2 col-sm-6">
                <input
                  type="button"
                  value="Cancel"
                  className="btn btn-block btn-secondary w-100"
                  onClick={() => {
                    navigate("/servers");
                  }}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
